import React, { FC } from 'react';
import { Box, Text } from '@bechtel/gds';
import { TimesheetCrewMemberProps } from './types';
import { AvatarRegularStyled } from './styled';
import { useName, PersonaMessages } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';

export const TimesheetCrewMember: FC<TimesheetCrewMemberProps> = ({ crewMember }) => {
  const { getFullName } = useName();
  return (
    <Box alignItems={{ sm: 'center' }} ml={{ sm: '500' }}>
      <AvatarRegularStyled src={crewMember?.imageUrl ? crewMember?.imageUrl : undefined} />
      <Box flexDirection={{ sm: 'column' }}>
        <Box mb={{ sm: '300' }}>
          <Text weight="600" size="400" color="white">
            {getFullName(crewMember.firstName, crewMember.lastName)}
          </Text>
        </Box>
        <Text size="300" color="white">
          <Trans id={PersonaMessages[crewMember?.persona].message}></Trans>
        </Text>
      </Box>
    </Box>
  );
};
